import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Modal } from 'react-bootstrap';
import { NavLink, useLocation, Route, Routes, Navigate } from 'react-router-dom';
import '../assets/AdminPanel.css';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/slice/authSlice';
import { routes } from '../routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark, faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';
import Logo from '../assets/logo.png';
import Cookies from 'js-cookie';
import SessionExpiryWarning from '../components/SessionExpiryWarning';
import Footer from '../components/Footer';

const AdminPanel = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();

  const tokenRefresh = Cookies.get('tokenRefresh')

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setSidebarOpen(false);
        setIsMobile(true);
      } else {
        setSidebarOpen(true);
        setIsMobile(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogout = () => {
    // Cookies.remove('tokenAccess'); // Διαγραφή cookie
    // Cookies.remove('tokenRefresh'); // Διαγραφή cookie
    dispatch(logout({ refresh: tokenRefresh })).then(() => { });
    // dispatch(setLogout(true));
  };

  const toggleSidebar = () => {
    if (isMobile) {
      setSidebarOpen(!sidebarOpen);
    }
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      }
      return null;
    });
  };

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? 'active' : '';
  };

  const handleShowLogoutModal = () => setShowLogoutModal(true);
  const handleCloseLogoutModal = () => setShowLogoutModal(false);

  // Συνάρτηση για να καθορίσετε τον τίτλο με βάση τη διαδρομή
  const getTitle = () => {
    const route = routes.find(route => route.path === location.pathname.replace('/admin', ''));
    return route ? route.name : 'Αρχική Σελίδα'; // Αν δεν βρείτε τίποτα, επιστρέψτε έναν προεπιλεγμένο τίτλο
  };

  return (
    <Container fluid className="admin-container">
      <Row className='admin-navbar'>
        <Col className='admin-col'>
          {isMobile && (
            <Button className="menu-btn" onClick={toggleSidebar} variant="dark">
              <FontAwesomeIcon icon={sidebarOpen ? faXmark : faBars} />
            </Button>
          )}
        </Col>
        <Col className='admin-col' xs={5} style={{ display: 'flex', justifyContent: 'center' }}>
          <h4>{getTitle()}</h4> {/* Χρησιμοποιήστε τη συνάρτηση για τον τίτλο */}
        </Col>
        <Col className='admin-col' style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
          <div>

            <FontAwesomeIcon icon={faUser} size='lg' style={{ marginRight: '10px', width: '20px' }} />
            <strong>Admin</strong>
          </div>
        </Col>
      </Row>

      <Row className='row-admin'>
        <Col xs={sidebarOpen ? 12 : 0} sm={sidebarOpen ? 12 : 0} md={sidebarOpen ? 12 : 0} lg={sidebarOpen ? 3 : 0} xl={2} xxl={2} className="sidebar" style={{ transform: sidebarOpen ? 'translateX(-0)' : 'translateX(-110%)' }}>
          <div className="sidebar-content">
            <div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', marginTop: '10px', marginBottom: '20px' }}>
                <img src={Logo} alt="react-logo" style={{ width: '40px', marginRight: '10px' }} />
                <strong>Λ.Α.Φ. Αλεξανδρούπολης</strong>
              </div>
              <ul className="sidebar-menu">
                {routes.map((route, index) => (
                  <li className={`sidebar-menu-item ${activeRoute(route?.path)}`} key={index}>
                    <NavLink
                      to={route?.layout + route?.path}
                      className="nav-link"
                      onClick={toggleSidebar}
                    >
                      <FontAwesomeIcon icon={route?.icon} size='sm' style={{ marginRight: '10px', width: '20px' }} />{route?.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <div onClick={handleShowLogoutModal} className={`sidebar-menu-item`}>
              <FontAwesomeIcon icon={faRightFromBracket} size='sm' style={{ marginRight: '10px', width: '20px' }} />Αποσύνδεση
            </div>
          </div>
        </Col>

        <Col xs={sidebarOpen ? 0 : 12} sm={sidebarOpen ? 0 : 12} md={sidebarOpen ? 0 : 12} lg={sidebarOpen ? 9 : 12} xl={8} xxl={10} className="main-content" style={{ marginLeft: sidebarOpen ? '280px' : '0px' }}>
          <Routes>
            {getRoutes(routes)}
            <Route path="/" element={<Navigate to="/admin/orders-management" replace />} />
            <Route path="*" element={<Navigate to="/admin/orders-management" replace />} />
          </Routes>
        </Col>
      </Row>

      {/* Modal Αποσύνδεσης */}
      <Modal show={showLogoutModal} onHide={handleCloseLogoutModal}>
        <Modal.Header closeButton>
          <Modal.Title>Επιβεβαίωση Αποσύνδεσης</Modal.Title>
        </Modal.Header>
        <Modal.Body>Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseLogoutModal}>
            <strong>Ακύρωση</strong>
          </Button>
          <Button variant="primary" onClick={() => { handleLogout(); handleCloseLogoutModal(); }}>
            <strong>Αποσύνδεση</strong>
          </Button>
        </Modal.Footer>
      </Modal>
      <SessionExpiryWarning />
      <Footer />
    </Container>
  );
};

export default AdminPanel;
